import { ForkEffect, takeEvery } from 'redux-saga/effects';
import { Socket } from 'socket.io-client';

import { send } from '../send-request';
import {
  downloaderAddWarehouseProduct,
  downloaderAddWarehouseProductAI,
  downloaderAddWarehouseProductAILocal,
  downloaderDeleteWarehouseProduct,
  downloaderDownloadAllPhotosWarehouseProduct,
  downloaderHideWarehouseProduct,
  downloaderLoadProduct,
  downloaderLoadProducts,
  downloaderLoadWarehouseCategories,
  downloaderLoadWarehouseCategoriesUnpaired,
  downloaderLoadWarehouseCategory,
  downloaderLoadWarehouseProduct,
  downloaderLoadWarehouseProducts,
  downloaderLoadWarehouseProductsByWarehouseCategory,
  downloaderLoadWarehouseProperties,
  downloaderLoadWarehouseProperty,
  downloaderPairWarehouseCategory,
  downloaderSyncWarehouseProduct,
  downloaderUnassignWarehouseProduct,
  downloaderUnpairWarehouseCategory,
  downloaderWarehouseProductPairWithExistingProduct,
  downloaderWarehouseProductSuggestionsLoad,
} from './reducer';

export function* watch(
  socket: Socket,
): Generator<ForkEffect<never>, void, string> {
  yield takeEvery(downloaderAddWarehouseProduct.type, send, socket);
  yield takeEvery(downloaderAddWarehouseProductAI.type, send, socket);
  yield takeEvery(downloaderAddWarehouseProductAILocal.type, send, socket);
  yield takeEvery(
    downloaderDownloadAllPhotosWarehouseProduct.type,
    send,
    socket,
  );
  yield takeEvery(downloaderDeleteWarehouseProduct.type, send, socket);
  yield takeEvery(downloaderHideWarehouseProduct.type, send, socket);
  yield takeEvery(downloaderLoadProduct.type, send, socket);
  yield takeEvery(downloaderLoadProducts.type, send, socket);
  yield takeEvery(downloaderLoadWarehouseCategories.type, send, socket);
  yield takeEvery(downloaderLoadWarehouseCategoriesUnpaired.type, send, socket);
  yield takeEvery(downloaderLoadWarehouseCategory.type, send, socket);
  yield takeEvery(downloaderLoadWarehouseProduct.type, send, socket);
  yield takeEvery(
    downloaderLoadWarehouseProductsByWarehouseCategory.type,
    send,
    socket,
  );
  yield takeEvery(downloaderLoadWarehouseProducts.type, send, socket);
  yield takeEvery(downloaderLoadWarehouseProperties.type, send, socket);
  yield takeEvery(downloaderLoadWarehouseProperty.type, send, socket);
  yield takeEvery(downloaderPairWarehouseCategory.type, send, socket);
  yield takeEvery(downloaderSyncWarehouseProduct.type, send, socket);
  yield takeEvery(downloaderUnassignWarehouseProduct.type, send, socket);
  yield takeEvery(downloaderUnpairWarehouseCategory.type, send, socket);
  yield takeEvery(
    downloaderWarehouseProductPairWithExistingProduct.type,
    send,
    socket,
  );
  yield takeEvery(downloaderWarehouseProductSuggestionsLoad.type, send, socket);
}
